import { Heading, Text } from "@/design-system";
import type { Integration } from "@/pages/landingPage/constants/integrations";
import { IntegrationCard } from "./integrationCard";

type IntegrationGroupProps = {
  id: string;
  title: string;
  description: string;
  integrations: Integration[];
};

export const IntegrationGroup = ({
  id,
  title,
  description,
  integrations,
}: IntegrationGroupProps) => (
  <section
    aria-labelledby={id}
    className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 sm:px-6 lg:px-8"
  >
    <div className="flex max-w-2xl flex-col gap-2">
      <Heading level={2} id={id}>
        {title}
      </Heading>
      <Text tone="subtle">{description}</Text>
    </div>
    <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {integrations.map(integration => (
        <li key={integration.name}>
          <IntegrationCard integration={integration} />
        </li>
      ))}
    </ul>
  </section>
);
